export default "__VITE_ASSET__AjUEXfvp__"